var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooteriig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7193 0C33.2806 0 42.7267 9.42073 42.7251 20.9543C42.7251 32.601 33.3053 41.9922 21.6321 41.9889C10.0001 41.9857 0.613186 32.5485 0.623055 20.8673C0.632923 9.37316 10.107 0.00164038 21.7193 0V0ZM21.6354 10.6428C21.6354 10.5936 21.6354 10.5428 21.6354 10.4935C20.2373 10.4935 18.8392 10.487 17.4428 10.4935C13.9542 10.5132 11.1679 13.2642 11.1481 16.7254C11.1317 19.5682 11.1317 22.4109 11.1481 25.2537C11.1679 28.6838 13.9312 31.4626 17.3556 31.4888C20.2324 31.5102 23.1108 31.5102 25.9892 31.4888C29.3824 31.4642 32.1671 28.7117 32.1983 25.3407C32.2247 22.4437 32.2214 19.5452 32.1983 16.6483C32.1753 13.7349 30.0897 11.0923 27.2064 10.6887C25.3839 10.4328 23.4957 10.6412 21.6371 10.6412L21.6354 10.6428Z",
    fill: "url(#paint0_linear_9084_1360)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0683 21.017C30.0683 22.4113 30.0798 23.804 30.0683 25.1983C30.0469 27.5802 28.3018 29.3485 25.93 29.3633C23.0812 29.3813 20.2308 29.3829 17.382 29.3633C15.0628 29.3468 13.2996 27.5687 13.2864 25.2393C13.2699 22.3982 13.2683 19.5554 13.2864 16.7142C13.3028 14.4013 15.0891 12.6428 17.4214 12.6313C20.2702 12.6166 23.1207 12.6149 25.9695 12.6313C28.2525 12.6444 30.0321 14.4079 30.0634 16.6732C30.0831 18.1217 30.0667 19.5702 30.0683 21.0186V21.017ZM21.6042 26.4138C24.6273 26.4319 27.0879 24.0468 27.1077 21.0826C27.1274 18.061 24.7474 15.6004 21.7818 15.5775C18.7011 15.5528 16.2503 17.9281 16.2421 20.9481C16.2322 23.9664 18.6172 26.3958 21.6058 26.4138H21.6042ZM27.0435 16.8947C27.7607 16.9488 28.3841 16.4354 28.4581 15.7267C28.537 14.9525 28.0304 14.316 27.2837 14.2553C26.5106 14.193 25.8774 14.7015 25.8017 15.4462C25.7293 16.1532 26.3165 16.8406 27.0435 16.8963V16.8947Z",
    fill: "url(#paint1_linear_9084_1360)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5941 24.2889C23.4905 24.3135 24.9594 22.9093 24.9774 21.0557C24.9955 19.2004 23.609 17.7388 21.7964 17.7044C19.8901 17.6666 18.4032 19.0528 18.3736 20.8949C18.3423 22.7912 19.742 24.2659 21.5941 24.2889Z",
    fill: "#012E40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5941 24.2889C19.7404 24.2643 18.3423 22.7896 18.3736 20.8949C18.4032 19.0528 19.8917 17.6666 21.7964 17.7044C23.609 17.7405 24.9955 19.202 24.9774 21.0557C24.9594 22.9093 23.4905 24.3135 21.5941 24.2889Z",
    fill: "url(#paint2_linear_9084_1360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9084_1360",
    x1: 21.6741,
    y1: 0,
    x2: 21.6741,
    y2: 41.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0545C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF814B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9084_1360",
    x1: 21.6734,
    y1: 12.6196,
    x2: 21.6734,
    y2: 29.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7C4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9084_1360",
    x1: 21.6753,
    y1: 17.7036,
    x2: 21.6753,
    y2: 24.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB774F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooteriig);
export default __webpack_public_path__ + "static/media/footer iig.9dbf5e7b33ea4568ece8fb2610d35704.svg";
export { ForwardRef as ReactComponent };